import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ActivationEnd,
  ActivationStart,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (localStorage.getItem('access_token')) {
      return true;
    } else {
      const eventsRegex = /\/events.*/;
      const whiteListedRoutes = [eventsRegex];

      const canView = whiteListedRoutes.some(route => route.test(state.url));
      if (canView) {
        return true;
      } else {
        this.router.navigate(['auth/login']).then();
      }
    }
  }
}
